import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-55b89f2c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "settings-page"
};
const _hoisted_2 = {
  class: "settings-hero glass-panel"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hero-copy"
}, [/*#__PURE__*/_createElementVNode("h2", null, "设置"), /*#__PURE__*/_createElementVNode("p", null, "管理登录通道与客户端偏好。切换后会影响学校列表、扫码登录和后续请求。")], -1));
const _hoisted_4 = {
  class: "current-mode-card"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前通道", -1));
const _hoisted_6 = {
  class: "api-settings glass-panel"
};
const _hoisted_7 = {
  class: "settings-section-head"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "接口通道")], -1));
const _hoisted_9 = {
  class: "mode-grid"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "mode-code"
};
const _hoisted_12 = {
  class: "password-console glass-panel"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "settings-section-head"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h3", null, "密码重置 / 安全自测")])], -1));
const _hoisted_14 = {
  class: "password-grid"
};
const _hoisted_15 = {
  class: "password-card"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前账号改密", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "/apis/user/reset-passwd", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "需要已登录 Class 会话和原密码，只作用于当前账号。", -1));
const _hoisted_19 = {
  class: "password-card audit"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权重置测试", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "/uc/user/send-code + /uc/user/reset-password", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 已开放 username / sid / phone 输入；只用在你有授权的测试账号，提交前会再次确认。 ", -1));
const _hoisted_23 = {
  key: 0,
  class: "school-tag"
};
const _hoisted_24 = {
  class: "school-sid"
};
const _hoisted_25 = {
  class: "password-actions compact"
};
const _hoisted_26 = {
  class: "password-actions"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "/apis/personal/send/code", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "旧版手机号验证码接口，字段只传 phone 和可选 type。", -1));
const _hoisted_29 = {
  class: "password-actions"
};
const _hoisted_30 = {
  class: "password-result"
};
const _hoisted_31 = {
  class: "settings-info-grid"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("article", {
  class: "settings-note glass-panel"
}, [/*#__PURE__*/_createElementVNode("span", null, "登录体验"), /*#__PURE__*/_createElementVNode("h4", null, "学校列表会随通道变化"), /*#__PURE__*/_createElementVNode("p", null, " “传统 Web”和“新版 Class”会分别只展示对应平台学校；“智能匹配”会合并展示并自动判断。 ")], -1));
const _hoisted_33 = {
  class: "settings-note glass-panel"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前会话", -1));
import { computed, onMounted, onUnmounted, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { API_MODE_CHANGED_EVENT, API_MODE_OPTIONS, getApiMode, getApiModeOption, setApiMode } from "@/utils/apiMode";
import { changeClassPassword, getClassSchools, getClassForgotPasswordPhone, getClassSelfUsername, getSchoolSid, getSchools, isClassSession, resetClassForgotPassword, sendClassForgotPasswordCode, sendClassPersonalCode } from "@/utils/api";
export default {
  __name: 'SettingsPage',
  setup(__props) {
    const apiMode = ref(getApiMode());
    const options = API_MODE_OPTIONS;
    const passwordForm = ref({
      originPassword: "",
      password: "",
      confirmPassword: ""
    });
    const forgotForm = ref({
      username: "",
      sid: "",
      password: "",
      confirmPassword: "",
      phone: "",
      type: ""
    });
    const passwordLoading = ref(false);
    const passwordAction = ref("");
    const passwordResultText = ref("");
    const schoolLoading = ref(false);
    const schoolList = ref([]);
    const readUserData = () => {
      try {
        return JSON.parse(localStorage.getItem("userData") || "null");
      } catch {
        return null;
      }
    };
    const currentOption = computed(() => getApiModeOption(apiMode.value));
    const userData = computed(() => readUserData());
    const loggedIn = computed(() => localStorage.getItem("loggedIn") === "true" && userData.value);
    const currentUsername = computed(() => getClassSelfUsername(userData.value) || "");
    const currentSid = computed(() => userData.value?.sid || "");
    const canUseClassSession = computed(() => Boolean(loggedIn.value && isClassSession(userData.value)));
    const targetUsername = computed(() => String(forgotForm.value.username || "").trim());
    const targetSid = computed(() => String(forgotForm.value.sid || "").trim());
    const targetPhone = computed(() => String(forgotForm.value.phone || "").trim());
    const canUseForgotPasswordApi = computed(() => Boolean(targetUsername.value && targetSid.value));
    const canUsePhoneCodeApi = computed(() => Boolean(canUseClassSession.value && targetPhone.value));
    const passwordAuditText = computed(() => {
      if (!canUseClassSession.value) {
        return "忘记密码接口可填 username + sid 测试；旧版手机号发码需要先登录 Class 会话。";
      }
      return "已开放授权测试输入：忘记密码只传 username + sid；旧版手机号发码只传 phone + 可选 type。";
    });
    const sessionTitle = computed(() => {
      if (!loggedIn.value) return "尚未登录";
      return isClassSession(userData.value) ? "已登录新版 Class" : "已登录传统 Web";
    });
    const sessionText = computed(() => {
      if (!loggedIn.value) return "登录前可先选择通道，登录页会按当前设置刷新学校列表。";
      return "通道设置主要影响下一次登录与旧接口来源参数；如需更换平台，请重新登录。";
    });
    const modeHint = mode => {
      const hints = {
        auto: "推荐：优先保证可用性",
        web: "旧版学校 / 传统接口",
        class: "新平台学校 / Class 接口",
        ios: "实验：App 来源参数"
      };
      return hints[mode] || "";
    };
    const chooseApiMode = mode => {
      apiMode.value = setApiMode(mode);
    };
    const resetApiMode = () => {
      chooseApiMode("auto");
    };
    const normalizeClassSchool = school => ({
      ...school,
      go_id: school.id,
      is_go: 1,
      apiPlatform: "class"
    });
    const schoolPlatformLabel = school => {
      if (school.apiPlatform === "class") return "Class";
      if (school.apiPlatform === "web") return "Web";
      return "";
    };
    const toSchoolOption = school => {
      const sid = getSchoolSid(school);
      if (!Number.isFinite(sid) || sid <= 0) return null;
      return {
        key: `${school.name || "school"}:${sid}:${school.apiPlatform || ""}`,
        name: school.name || `学校 ${sid}`,
        label: `${school.name || `学校 ${sid}`}（sid: ${sid}）`,
        sid: String(sid),
        platform: schoolPlatformLabel(school)
      };
    };
    const fetchSchoolsForPassword = async () => {
      schoolLoading.value = true;
      try {
        const loadLegacySchools = apiMode.value !== "class";
        const loadClassSchools = apiMode.value !== "web" && apiMode.value !== "ios";
        const [legacyResult, classResult] = await Promise.allSettled([loadLegacySchools ? getSchools({
          silent: true
        }) : Promise.resolve([]), loadClassSchools ? getClassSchools({
          silent: true
        }) : Promise.resolve({
          data: {
            list: []
          }
        })]);
        const legacySchools = legacyResult.status === "fulfilled" && Array.isArray(legacyResult.value) ? legacyResult.value.map(school => ({
          ...school,
          apiPlatform: "web"
        })) : [];
        const classSchools = classResult.status === "fulfilled" ? (classResult.value?.data?.list || []).map(normalizeClassSchool) : [];
        const merged = new Map();
        const pushSchool = school => {
          const option = toSchoolOption(school);
          if (!option) return;
          const existing = merged.get(option.sid);
          if (!existing || option.platform === "Class") merged.set(option.sid, option);
        };
        if (apiMode.value === "class") {
          classSchools.forEach(pushSchool);
        } else if (apiMode.value === "web" || apiMode.value === "ios") {
          legacySchools.forEach(pushSchool);
        } else {
          legacySchools.forEach(pushSchool);
          classSchools.forEach(pushSchool);
        }
        schoolList.value = [...merged.values()].sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "zh-Hans-CN"));
      } catch (error) {
        ElMessage.error("获取学校列表失败，可直接手动输入 sid。");
        console.error(error);
      } finally {
        schoolLoading.value = false;
      }
    };
    const fillCurrentPasswordTarget = () => {
      forgotForm.value.username = currentUsername.value || "";
      forgotForm.value.sid = currentSid.value ? String(currentSid.value) : "";
    };
    const responseText = (response, fallback) => {
      const message = response?.msg || response?.message || response?.data?.msg || response?.data?.message;
      const code = response?.code ?? response?.data?.code;
      if (message) return code === undefined ? String(message) : `${message}（code: ${code}）`;
      if (code !== undefined) return `${fallback}（code: ${code}）`;
      return fallback;
    };
    const maskPhone = value => {
      const text = String(value || "").trim();
      if (!text) return "";
      return text.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
    };
    const phoneFromResponse = response => {
      const data = response?.data?.data || response?.data || response || {};
      return data.phone || data.mobile || data.tel || data.phoneNumber || data.bindPhone || "";
    };
    const confirmPasswordAction = config => ElMessageBox.confirm(config.message, "密码接口确认", {
      type: config.type || "warning",
      center: true,
      confirmButtonText: config.confirmText || "确认执行",
      cancelButtonText: "取消",
      autofocus: false
    });
    const submitPasswordAction = async action => {
      if (action === "change" && !canUseClassSession.value) {
        const message = "当前账号改密需要先登录新版 Class 会话。";
        passwordResultText.value = message;
        ElMessage.warning(message);
        return;
      }
      if (["phone", "code", "forgot-reset"].includes(action) && !canUseForgotPasswordApi.value) {
        const message = "请先填写目标 username 和学校 sid。";
        passwordResultText.value = message;
        ElMessage.warning(message);
        return;
      }
      if (action === "personal-code" && !canUsePhoneCodeApi.value) {
        const message = canUseClassSession.value ? "请先填写手机号。" : "旧版手机号发码需要先登录新版 Class 会话。";
        passwordResultText.value = message;
        ElMessage.warning(message);
        return;
      }
      const configs = {
        change: {
          message: "确认修改当前登录账号密码？不会在界面回显密码。",
          confirmText: "确认改密",
          type: "error"
        },
        phone: {
          message: `确认查询目标账号 ${targetUsername.value} 的绑定手机号？结果会原样显示。`,
          confirmText: "确认查询"
        },
        code: {
          message: `确认给目标账号 ${targetUsername.value} 的绑定手机号发送忘记密码验证码？这会真实触发短信。`,
          confirmText: "发送验证码",
          type: "warning"
        },
        "forgot-reset": {
          message: `确认通过忘记密码流程重置目标账号 ${targetUsername.value}？`,
          confirmText: "重置目标",
          type: "error"
        },
        "personal-code": {
          message: `确认调用旧版接口给手机号 ${maskPhone(targetPhone.value)} 发送验证码？这会真实触发短信。`,
          confirmText: "发送短信",
          type: "error"
        }
      };
      const config = configs[action];
      if (!config) return;
      try {
        await confirmPasswordAction(config);
      } catch {
        return;
      }
      passwordLoading.value = true;
      passwordAction.value = action;
      passwordResultText.value = "";
      try {
        let response;
        if (action === "change") {
          response = await changeClassPassword(userData.value, passwordForm.value.originPassword, passwordForm.value.password, passwordForm.value.confirmPassword);
          passwordResultText.value = `当前账号改密返回：${responseText(response, "已提交改密")}`;
        } else if (action === "phone") {
          response = await getClassForgotPasswordPhone(targetUsername.value, targetSid.value);
          const phone = phoneFromResponse(response);
          passwordResultText.value = phone ? `目标账号绑定手机号：${phone}` : `绑定手机号查询返回：${responseText(response, "已提交查询")}`;
        } else if (action === "code") {
          response = await sendClassForgotPasswordCode(targetUsername.value, targetSid.value);
          passwordResultText.value = `验证码发送返回：${responseText(response, "已请求发送验证码")}`;
        } else if (action === "forgot-reset") {
          response = await resetClassForgotPassword(targetUsername.value, targetSid.value, forgotForm.value.password, forgotForm.value.confirmPassword);
          passwordResultText.value = `忘记密码重置返回：${responseText(response, "已提交重置")}`;
        } else if (action === "personal-code") {
          response = await sendClassPersonalCode(userData.value, targetPhone.value, forgotForm.value.type);
          passwordResultText.value = `手机号验证码发送返回：${responseText(response, "已请求发送验证码")}`;
        }
        ElMessage.success(passwordResultText.value);
      } catch (error) {
        passwordResultText.value = error?.message || "密码接口调用失败";
        ElMessage.error(passwordResultText.value);
        console.error(error);
      } finally {
        passwordLoading.value = false;
        passwordAction.value = "";
      }
    };
    const syncMode = event => {
      apiMode.value = event?.detail?.mode || getApiMode();
      fetchSchoolsForPassword();
    };
    onMounted(() => {
      window.addEventListener(API_MODE_CHANGED_EVENT, syncMode);
      fetchSchoolsForPassword();
    });
    onUnmounted(() => window.removeEventListener(API_MODE_CHANGED_EVENT, syncMode));
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("strong", null, _toDisplayString(currentOption.value.label), 1), _createElementVNode("small", null, _toDisplayString(currentOption.value.description), 1)])]), _createElementVNode("section", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: resetApiMode
      }, {
        default: _withCtx(() => [_createTextVNode("恢复智能匹配")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), option => {
        return _openBlock(), _createElementBlock("button", {
          key: option.value,
          class: _normalizeClass(['mode-card', {
            active: apiMode.value === option.value
          }]),
          type: "button",
          onClick: $event => chooseApiMode(option.value)
        }, [_createElementVNode("span", _hoisted_11, _toDisplayString(option.shortLabel), 1), _createElementVNode("h4", null, _toDisplayString(option.label), 1), _createElementVNode("p", null, _toDisplayString(option.description), 1), _createElementVNode("small", null, _toDisplayString(modeHint(option.value)), 1)], 10, _hoisted_10);
      }), 128))])]), _createElementVNode("section", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("article", _hoisted_15, [_hoisted_16, _hoisted_17, _hoisted_18, _createVNode(_component_el_input, {
        modelValue: passwordForm.value.originPassword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => passwordForm.value.originPassword = $event),
        "show-password": "",
        type: "password",
        placeholder: "原密码"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: passwordForm.value.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => passwordForm.value.password = $event),
        "show-password": "",
        type: "password",
        placeholder: "新密码"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: passwordForm.value.confirmPassword,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => passwordForm.value.confirmPassword = $event),
        "show-password": "",
        type: "password",
        placeholder: "确认新密码"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "danger",
        plain: "",
        disabled: !canUseClassSession.value || passwordLoading.value,
        loading: passwordLoading.value && passwordAction.value === 'change',
        onClick: _cache[3] || (_cache[3] = $event => submitPasswordAction('change'))
      }, {
        default: _withCtx(() => [_createTextVNode(" 修改当前账号密码 ")]),
        _: 1
      }, 8, ["disabled", "loading"])]), _createElementVNode("article", _hoisted_19, [_hoisted_20, _hoisted_21, _hoisted_22, _createVNode(_component_el_input, {
        modelValue: forgotForm.value.username,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => forgotForm.value.username = $event),
        clearable: "",
        placeholder: "目标 username / 学号"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: forgotForm.value.sid,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => forgotForm.value.sid = $event),
        loading: schoolLoading.value,
        "allow-create": "",
        clearable: "",
        "default-first-option": "",
        filterable: "",
        placeholder: "选择学校或直接输入 sid"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolList.value, school => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: school.key,
            label: school.label,
            value: school.sid
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(school.name), 1), school.platform ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(school.platform), 1)) : _createCommentVNode("", true), _createElementVNode("small", _hoisted_24, "sid: " + _toDisplayString(school.sid), 1)]),
            _: 2
          }, 1032, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "loading"]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
        disabled: !currentUsername.value,
        onClick: fillCurrentPasswordTarget
      }, {
        default: _withCtx(() => [_createTextVNode(" 填当前账号 ")]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        loading: schoolLoading.value,
        onClick: fetchSchoolsForPassword
      }, {
        default: _withCtx(() => [_createTextVNode(" 刷新学校 ")]),
        _: 1
      }, 8, ["loading"])]), _createVNode(_component_el_input, {
        modelValue: forgotForm.value.password,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => forgotForm.value.password = $event),
        "show-password": "",
        type: "password",
        placeholder: "忘记密码流程的新密码"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: forgotForm.value.confirmPassword,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => forgotForm.value.confirmPassword = $event),
        "show-password": "",
        type: "password",
        placeholder: "确认新密码"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_button, {
        disabled: !canUseForgotPasswordApi.value || passwordLoading.value,
        loading: passwordLoading.value && passwordAction.value === 'phone',
        onClick: _cache[8] || (_cache[8] = $event => submitPasswordAction('phone'))
      }, {
        default: _withCtx(() => [_createTextVNode(" 查目标绑定手机号 ")]),
        _: 1
      }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
        disabled: !canUseForgotPasswordApi.value || passwordLoading.value,
        loading: passwordLoading.value && passwordAction.value === 'code',
        onClick: _cache[9] || (_cache[9] = $event => submitPasswordAction('code'))
      }, {
        default: _withCtx(() => [_createTextVNode(" 给目标发验证码 ")]),
        _: 1
      }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
        type: "warning",
        plain: "",
        disabled: !canUseForgotPasswordApi.value || passwordLoading.value,
        loading: passwordLoading.value && passwordAction.value === 'forgot-reset',
        onClick: _cache[10] || (_cache[10] = $event => submitPasswordAction('forgot-reset'))
      }, {
        default: _withCtx(() => [_createTextVNode(" 重置目标账号 ")]),
        _: 1
      }, 8, ["disabled", "loading"])]), _hoisted_27, _hoisted_28, _createVNode(_component_el_input, {
        modelValue: forgotForm.value.phone,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => forgotForm.value.phone = $event),
        clearable: "",
        placeholder: "任意手机号 phone"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: forgotForm.value.type,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => forgotForm.value.type = $event),
        clearable: "",
        placeholder: "type，可留空"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
        type: "danger",
        plain: "",
        disabled: !canUsePhoneCodeApi.value || passwordLoading.value,
        loading: passwordLoading.value && passwordAction.value === 'personal-code',
        onClick: _cache[13] || (_cache[13] = $event => submitPasswordAction('personal-code'))
      }, {
        default: _withCtx(() => [_createTextVNode(" 给手机号发验证码 ")]),
        _: 1
      }, 8, ["disabled", "loading"])]), _createElementVNode("p", _hoisted_30, _toDisplayString(passwordResultText.value || passwordAuditText.value), 1)])])]), _createElementVNode("section", _hoisted_31, [_hoisted_32, _createElementVNode("article", _hoisted_33, [_hoisted_34, _createElementVNode("h4", null, _toDisplayString(sessionTitle.value), 1), _createElementVNode("p", null, _toDisplayString(sessionText.value), 1)])])]);
    };
  }
};